import { render, staticRenderFns } from "./EventCompanyDialog.vue?vue&type=template&id=4da3cf16&scoped=true"
import script from "./EventCompanyDialog.vue?vue&type=script&lang=ts"
export * from "./EventCompanyDialog.vue?vue&type=script&lang=ts"
import style0 from "./EventCompanyDialog.vue?vue&type=style&index=0&id=4da3cf16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da3cf16",
  null
  
)

export default component.exports